<template>
  <AdminView>
    <h1 class="title-1">Proches Familiaux</h1>

    <div class="column">
      <PrescriberForm v-for="(familyMember, i) in familyMembers" :key="i"
        :prescriber="familyMember"
      />
    </div>

    <div class="buttons-container">
      <Button
        title="Ajouter un prescripteur"
        type="primary"
        @click="addPrescriber()"
      >
        <SVGPlus />
      </Button>
    </div>
  </AdminView>
</template>

<script>
import AdminView from '@/components/AdminView'
import PrescriberForm from '@/components/Forms/PrescriberForm'
import Button from '@/components/Button'
import SVGPlus from '@/assets/icons/plus.svg'

export default {
  name: 'FamilyMembersList',
  components: {
    AdminView, PrescriberForm, Button, SVGPlus
  },
  data () {
    return {
      familyMembers: [
        {
          firstname: 'John',
          lastname: 'Doe',
          email: 'john.doe@latelier.co',
          phone: '0600000000',
          location: 'Paris',
          sendData: true
        },
        {
          firstname: 'John',
          lastname: 'Doe',
          email: 'john.doe@latelier.co',
          phone: '0600000000',
          location: 'Paris',
          sendData: false
        }
      ]
    }
  },
  methods: {
    addPrescriber () {
      this.prescribers.push({})
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-container{
  display: flex;
  justify-content: center;
  margin: 20px 0;

  div {
    flex: 0;
  }
}
</style>
